import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "inner-content" }
const _hoisted_2 = { class: "header" }
const _hoisted_3 = { class: "content" }

import {ref,reactive,onMounted,onBeforeUnmount,computed} from 'vue'
import {useStore} from 'vuex'
import {useRouter, useRoute} from 'vue-router'


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  emits: ["onBack"],
  setup(__props, { emit: __emit }) {

const emit = __emit

const store = useStore()
const router = useRouter()
const route = useRoute()

const pageName = computed(()=>{
  return route.path == '/secondary/grade' || route.path == '/secondary/grade'
    ? '成绩'
    : route.path == '/secondary/setting'
      ? '设置'
      : route.path == '/secondary/tutorial-center'
        ? '教程中心'
        : '';
})

function handleBack(){
    window?.playClick()
    // 触发关闭弹窗事件（供弹窗模式使用）
    window.listenEvent.emit('close-remote-setting');
    // 正常返回
    router.back()
}

return (_ctx: any,_cache: any) => {
  const _component_vkm_svg = _resolveComponent("vkm-svg")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["secondary-container", { 'tutorial-center-layout': _unref(route).path === '/secondary/tutorial-center' }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_vkm_svg, {
          "icon-name": "back",
          class: "icon",
          onClick: handleBack
        }),
        _createElementVNode("p", null, _toDisplayString(pageName.value), 1)
      ]),
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(), _createBlock(_component_router_view, {
          key: _unref(route).fullPath
        }))
      ])
    ])
  ], 2))
}
}

})